<div class="mt-4 mx-4">

  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

  <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="fees-tab">
    <div class="card shadow-sm border-0">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-md-12 col-sm-12">
            <div class="p-3 rounded-3 border bg-light h-100">
              <div class="small text-muted d-flex align-items-center gap-2">
                <i class="bi bi-graph-up-arrow"></i>
                Cumulative Income
              </div>
              <div class="fw-semibold mt-1" style="font-size:1.25rem;">
                LKR {{ (dashboard?.cumulativeIncome) | number:'1.2-2' }}
              </div>
              <div class="text-muted small mt-1">
                Below, you can see totals per fee code with descriptions. You can search the list and open a fee to view
                its recent history and filter by date.
              </div>
            </div>
          </div>
        </div>

        <div class="row align-items-center mb-3 mt-2">

          <!-- Search -->
          <div class="col-md-12 col-sm-12 mb-2 mb-md-0">
            <div class="position-relative">
              <input id="searchFees" type="text" class="form-control user-search-input shadow-none"
                placeholder="Type here..." [(ngModel)]="searchText" (input)="performSearch()" />
              <span class="search-icon" (click)="performSearch()">
                <i class="bi bi-search"></i>
              </span>
            </div>
          </div>
        </div>

        <!-- Loading -->
        <div *ngIf="isLoading" class="text-muted">Loading fees...</div>

        <div *ngIf="!isLoading && trnFeeError" class="text-center py-5">
          <i class="bi bi-inbox fs-1 text-muted mb-3 d-block"></i>
          <p class="text-muted">No records found.</p>
        </div>

        <!-- Search returned no matches (history loaded fine, but filter is empty) -->
        <div *ngIf="!isLoading && !trnFeeError && filteredFees.length === 0 && searchText" class="text-center py-5">
          <i class="bi bi-inbox fs-1 text-muted mb-3 d-block"></i>
          <p class="text-muted">No matching results for "{{ searchText }}".</p>
        </div>

        <!-- Table -->
        <div *ngIf="filteredFees.length > 0 && !trnFeeError" class="table-responsive-wrapper">
          <table class="table table-striped">
            <thead>
              <tr>
                <th class="table-title text-start">Fee Code</th>
                <th class="table-title text-start">Description</th>
                <th class="table-title text-end">Total</th>
                <th class="table-title text-center">
                </th>
              </tr>
            </thead>
            <tbody>
              <!-- paginate here -->
              <tr *ngFor="let fee of pagedFees">
                <td class="table-data-text text-start">{{ fee.trnFeeCode }}</td>
                <td class="table-data-text text-start">{{ fee.trnFeeDesc }}</td>
                <td class="table-data-text text-end">{{ (fee.total ?? 0) | number:'1.2-2' }}</td>
                <td class="table-data-text text-center">
                  <button class="btn p-0" style="background: none; border: none;" [disabled]="(fee.total ?? 0) === 0"
                    [attr.aria-disabled]="(fee.total ?? 0) === 0"
                    [attr.title]="(fee.total ?? 0) === 0 ? 'No data available' : 'View details'"
                    [attr.data-bs-toggle]="(fee.total ?? 0) === 0 ? null : 'offcanvas'"
                    [attr.data-bs-target]="(fee.total ?? 0) === 0 ? null : '#feeViewOffcanvas'"
                    (click)="openViewFee(fee)">
                    <i class="bi bi-arrow-right" style="font-size: 1.2rem;"
                      [style.color]="(fee.total ?? 0) === 0 ? '#adb5bd' : 'var(--primary-color)'"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Pagination toolbar -->
          <app-paginator [serverSide]="true" [totalItems]="totalFees" [pageSize]="feesPageSize"
            [pageSizeOptions]="[5, 10, 20, 50]" (pageChangeServer)="onCumulativeIncomePageChange($event)">
          </app-paginator>

        </div>


      </div>
    </div>
  </div>
</div>

<!-- View-Only Offcanvas (Fee Details) -->
<div #feeViewOffcanvasEl class="offcanvas offcanvas-end w-70" tabindex="-1" id="feeViewOffcanvas"
  aria-labelledby="feeViewOffcanvasLabel" data-bs-backdrop="static" data-bs-keyboard="false">

  <div class="offcanvas-header">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-10 d-flex align-items-center">
          <h5 class="offcanvas-title d-flex align-items-center gap-2 mb-0" id="feeViewOffcanvasLabel">
            <i class="bi fs-5 bi-receipt"></i>
            Fee Details
          </h5>
        </div>
        <div class="col-2 text-end">
          <span type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"
            (click)="closeOffCanvas()"></span>
        </div>
      </div>
    </div>
  </div>

  <div class="offcanvas-body">
    <div *ngIf="selectedFee as f">

      <!-- Summary cards -->
      <div class="row g-3">
        <div class="col-md-4">
          <div class="p-3 rounded-3 border h-100">
            <div class="small text-muted mb-1"><i class="bi bi-tag me-1"></i>Fee Code</div>
            <div class="fw-semibold d-flex align-items-center">
              <span>{{ f.trnFeeCode }}</span>
            </div>
          </div>
        </div>

        <div class="col-md-5">
          <div class="p-3 rounded-3 border h-100">
            <div class="small text-muted mb-1"><i class="bi bi-card-text me-1"></i>Description</div>
            <div class="fw-semibold d-flex align-items-center">
              <span>{{ f.trnFeeDesc }}</span>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="p-3 rounded-3 border h-100">
            <div class="small text-muted mb-1"><i class="bi bi-currency-exchange me-1"></i>Total</div>
            <div class="fw-semibold d-flex align-items-center">
              <span>{{ (f.total ?? 0) | number:'1.2-2' }}</span>
            </div>
          </div>
        </div>
      </div>

      <hr />
      <!-- History search (inside offcanvas) -->
      <div class="row align-items-center mb-3 mt-3">

        <div class="col-md-12 col-sm-12 mb-2 mb-md-0">
          <div class="d-flex align-items-center gap-2 flex-nowrap">

            <!-- Search input -->
            <div class="position-relative flex-grow-1 min-width-0">
              <input id="searchUser" type="text" class="form-control user-search-input shadow-none"
                placeholder="Type here..." [(ngModel)]="historySearchText" (input)="performHistorySearch()" />

              <span class="search-icon" (click)="performHistorySearch()">
                <i class="bi bi-search"></i>
              </span>
            </div>

            <!-- Advanced Filter -->
            <div class="flex-shrink-0 advanced-filter-wrapper">
              <app-filter-panel #filterPanel title="Advanced Filter" [fields]="feeFilterFields"
                (filterApplied)="onFeeFilter($event)" (filterCleared)="onFeeClear()">
              </app-filter-panel>
            </div>

          </div>
        </div>
        <div class="col-md-3 col-sm-12 text-md-end text-start"></div>
      </div>

      <!-- Date range pickers -->
      <div class="row g-3 align-items-end">
        <div class="col-md-4">
          <label class="label-text">Start Date</label>
          <input type="date" class="form-control rounded-pill shadow-none input-text" [(ngModel)]="startDate"
            [max]="endDate || todayYMD" (change)="onDateRangeChange()" (keyup.enter)="onDateRangeChange()" />
        </div>
        <div class="col-md-4">
          <label class="label-text">End Date</label>
          <input type="date" class="form-control rounded-pill shadow-none input-text" [(ngModel)]="endDate"
            [min]="startDate || null" [max]="todayYMD" (change)="onDateRangeChange()"
            (keyup.enter)="onDateRangeChange()" />
        </div>
      </div>

      <!-- Loading -->
      <div *ngIf="isHistoryLoading" class="text-muted mt-3">Loading history...</div>

      <div *ngIf="!isHistoryLoading && historyError" class="text-center py-5">
        <i class="bi bi-inbox fs-1 text-muted mb-3 d-block"></i>
        <p class="text-muted">No records found.</p>
      </div>

      <!-- Search returned no matches (history loaded fine, but filter is empty) -->
      <div
        *ngIf="!isHistoryLoading && !historyError && history.length > 0 && filteredHistory.length === 0 && historySearchText"
        class="text-center py-5">
        <i class="bi bi-inbox fs-1 text-muted mb-3 d-block"></i>
        <p class="text-muted">No matching results for "{{ historySearchText }}".</p>
      </div>

      <!-- History table -->
      <div *ngIf="filteredHistory.length > 0 && !historyError" class="table-responsive-wrapper mt-3">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="table-title text-start">Date &amp; Time</th>
              <th class="table-title text-start">Company</th>
              <th class="table-title text-start">Company ID</th>
              <th class="table-title text-end">Transaction Fee</th>
            </tr>
          </thead>
          <tbody>
            <!-- paginate here -->
            <tr *ngFor="let row of pagedHistory">
              <td class="table-data-text text-start">{{ formatDateTime(row.createdDate) }}</td>
              <td class="table-data-text text-start">{{ row.companyName }}</td>
              <td class="table-data-text text-start">{{ row.companyId }}</td>
              <td class="table-data-text text-end">{{ (row.transactionFee ?? 0) | number:'1.2-2' }}</td>
            </tr>
          </tbody>
        </table>

        <!-- Pagination toolbar -->
        <app-paginator [serverSide]="true" [totalItems]="totalHistory" [pageSize]="historyPageSize"
          [pageSizeOptions]="[5, 10, 20, 50]" (pageChangeServer)="onHistoryPageChange($event)">
        </app-paginator>

      </div>

    </div>
  </div>
</div>